import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  couponData: {},
}

const KpCouponSlice = createSlice({
  name: 'kpCouponState',
  initialState,
  reducers: {
    setCouponData(state, action) {
      const dedup = arr =>
        (arr || []).filter(
          (c, i, self) => self.findIndex(x => x.code === c.code) === i,
        )
      state.couponData = {
        defaultObFeeCoupon: dedup(action.payload.defaultObFeeCoupon),
        plansIncentive: dedup(action.payload.plansIncentive),
        promotions: dedup(action.payload.promotions),
      }
    },
    resetCouponData(state) {
      state.couponData = {}
    },
  },
})

export const selectedCouponData = state => state.kpCouponState.couponData

export const {setCouponData, resetCouponData} = KpCouponSlice.actions
export default KpCouponSlice.reducer
